import { motion } from 'framer-motion';
import React from 'react';
import './Home.scss';
import { Logo } from './icons';
import LogoCb from './color-berry-logo.png';
import { storage } from '../../services/config/storage';
import { GC } from '../../services/config/gamecentreService';

const Home = (props) => {

    const gameDetails = storage.get.gameDetails();
 
    return (
        <div className="home">
            <motion.div
                initial={{ marginTop: "350px", width: "400px", height: "90px" }}
                animate={{ marginTop: "0px", width: "250px", height: "90px" }}
                transition={{ delay: 0.25, duration: "1" }}
                className="logocont"
            >
                {
                    gameDetails?.mediaUrl ?
                    <img src={gameDetails.mediaUrl} style={{ width: "100%", height: "100%", objectFit: "contain" }} /> :
                    <img src={LogoCb} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                }
                {
                    gameDetails?.organizationName &&
                    <motion.div
                        initial={{ marginTop: "30px", width: "400px", height: "90px",fontSize: '18px', }}
                        animate={{ marginTop: "0px", marginLeft: "56px", width: "250px", height: "90px", fontSize: '14px', }}
                        transition={{ delay: 0.25, duration: "1" }} 
                        style={{ position: 'relative', bottom: "25px"}}
                    >
                        <span style={{ fontSize: '15px', fontWeight: '100', color: '#d6d6d6', fontFamily: 'Apercu' }}>powered by </span>
                        <span style={{ fontSize: '18px', fontWeight: '500', color: 'white', fontFamily: 'Apercu' }}> {gameDetails.organizationName}</span>
                    </motion.div>
                }
            </motion.div>
            <motion.div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                }}
                initial="hidden"
                animate="visible"
                transition={{ ease: "easeOut", duration: 2, delay: 1 }}
                variants={{
                    visible: { opacity: 1 },
                    hidden: { opacity: 0 },
                }}
            >
                <div className="instructions">
                    <h5>🎯  Instructions</h5>
                    <h6 style={{ marginBottom: "8px" }}>This game has two chapters, both require you to understand the instructions and follow them through.</h6>
                    <h6 style={{ marginTop: "5px" }}>You will be playing each chapter twice</h6>
                </div>
                <div className="button-container">
                    <div className="game-info">
                        <div>
                            <h6>Chapters</h6>
                            <h4>2</h4>
                        </div>
                        <div className="bar" />
                        <div>
                            <h6>Time</h6>
                            <h4>60s</h4>
                        </div>
                    </div>

                </div>
                <button 
                    onClick={() => {
                        const gameData = storage.get.levelData() ?? {};
                        if (gameData && !gameData?.levelData?.length) {
                            GC.createGameMasterSession();
                        }
                        props.onClick()
                    }} 
                    className={`questionOptions style-4`}
                >
                    <span>START GAME</span>
                </button>
            </motion.div>

        </div>
    );
}

export default Home;